import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { InviteAdminStaffPayload, UpdateAdminStaffPayload } from '../models/admin-staff.models';

@Injectable({
  providedIn: 'root',
})
export class AdminStaffService {
  private baseAPI = environment.baseAPI;

  constructor(private http: HttpClient) {}

  inviteAdminStaff(payload: InviteAdminStaffPayload) {
    return this.http.post(`${this.baseAPI}/admin-staff`, payload);
  }

  getAdminStaff(params: {
    search?: string;
    status?: string;
    pageNumber?: number;
    pageSize?: number;
  }) {
    let httpParams = new HttpParams()
      .set('pageNumber', (params.pageNumber || 1).toString())
      .set('pageSize', (params.pageSize || 20).toString());

    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.status) httpParams = httpParams.set('status', params.status);

    return this.http.get(`${this.baseAPI}/admin-staff`, { params: httpParams });
  }

  updateAdminStaff(staffUserId: string, payload: UpdateAdminStaffPayload) {
    return this.http.put(`${this.baseAPI}/admin-staff/${staffUserId}`, payload);
  }

  removeAdminStaff(staffUserId: string) {
    return this.http.delete(`${this.baseAPI}/admin-staff/${staffUserId}`);
  }

  resendInvitation(staffUserId: string) {
    return this.http.post(`${this.baseAPI}/admin-staff/${staffUserId}/resend-invitation`, {});
  }

  setAccess(staffUserId: string, enable: boolean) {
    const params = new HttpParams().set('enable', enable.toString());
    return this.http.patch(`${this.baseAPI}/admin-staff/${staffUserId}/access`, {}, { params });
  }

  getSummary() {
    return this.http.get(`${this.baseAPI}/admin-staff/summary`);
  }

  getMyProfile() {
    return this.http.get(`${this.baseAPI}/admin-staff/profile`);
  }
}
